import Swal from 'sweetalert2';

export const openCovidSignatureAlert = (covidSignatureOverridden: boolean) => {
  if (covidSignatureOverridden) {
    Swal.fire({
      type: 'success',
      title: 'Signature not required',
      text: 'A signature is not required for this showing, no further action is required.',
      confirmButtonColor: '#62cb31',
      confirmButtonText: 'Done',
    });
  } else {
    Swal.fire({
      type: 'success',
      title: 'Form has already been signed',
      text: 'This Form has already been signed and no further action is required.',
      confirmButtonColor: '#62cb31',
      confirmButtonText: 'Done',
    });
  }
};
